// extracted by mini-css-extract-plugin
export var button = "Button-module--button--2t432";
export var basic = "Button-module--basic--332p4";
export var invert = "Button-module--invert--3pinC";
export var large = "Button-module--large--1KHrG";
export var fullWidth = "Button-module--full-width--11Nnx";